import React, { useEffect } from 'react'
import mobileExchangerOrderScreen from '../../../redux/stores/MobileExchangerOrder/OrderScreenAction'
import { useSelector } from 'react-redux'
import classes from '../MobileExchanger.module.css'
import StatusCode from '../../elements/statusCode'
import currencyName from '../elements/currency'
import CurrencyCodeName from '../elements/CurrencyName'
import IconCurrency from '../../elements/currencyMobile'
import Loader from '../../../images/icon/loaderWhite.svg'

export default function MobileExchangerOrder () {
    const state = useSelector(state => state.mobileExchangerOrder)

    useEffect(() => {
        mobileExchangerOrderScreen()
    }, [])

    const renderMobileOrderStatus = () => {
        if (!state.mobileOrderInfo) {
            return
        }

        return (
            <div className={classes.main}>
                <div className={classes.wrapper}>
                    <div className={classes.content}>
                        <div className={classes.status__wrapper}>
                            <div className={classes.status__currency}>
                                <div className={classes.status__way}>
                                    <IconCurrency currencyCode={state.mobileOrderInfo.inCurrencyCode}/>
                                    <div className={classes.status__line}></div>
                                    <div className={classes.status__circle}>
                                        <img src={Loader} alt={'loader'} width={32} style={{ marginTop: 5 }}/>
                                    </div>
                                    <div className={classes.status__line}></div>
                                    <IconCurrency currencyCode={state.mobileOrderInfo.outCurrencyCode}/>
                                </div>
                            </div>
                            <div className={classes.status}>
                                <StatusCode code={state.mobileOrderInfo.orderStatus}/>
                            </div>
                        </div>
                        <div className={classes.data__wrapper}>
                            <div className={classes.data__name}>
                                <div className={classes.data}>
                                    You give:
                                </div>
                                <div className={classes.data}>
                                    {currencyName[state.mobileOrderInfo.inCurrencyCode]}
                                </div>
                            </div>
                            <div className={classes.data__value}>
                                {state.mobileOrderInfo.inAmount} {CurrencyCodeName[state.mobileOrderInfo.inCurrencyCode]}
                            </div>
                        </div>
                        <div className={classes.main__wrapper}>
                            <div className={classes.post__wrapper}>
                                <div className={classes.post}>
                                    Order ID
                                </div>
                                <div className={classes.rate}>
                                    <div className={classes.post__value}>
                                        {state.mobileOrderInfo.orderHash}
                                    </div>
                                </div>
                            </div>
                            <div className={classes.post__wrapper}>
                                <div className={classes.post}>
                                    Destination address
                                </div>
                                <div className={classes.rate}>
                                    <div className={classes.post__value}>
                                        {state.mobileOrderInfo.outDestination}
                                    </div>
                                </div>
                            </div>
                            <div className={classes.post__wrapper}>
                                <div className={classes.post}>
                                    Provider
                                </div>
                                <div className={classes.rate}>
                                    <div className={classes.post__value}>
                                        {state.mobileOrderInfo.providerName}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={classes.data__wrapper}>
                            <div className={classes.data__name}>
                                <div className={classes.data}>
                                    You expect:
                                </div>
                                <div className={classes.data}>
                                    {currencyName[state.mobileOrderInfo.outCurrencyCode]}
                                </div>
                            </div>
                            <div className={classes.data__value} style={{ color: '#7127AC' }}>
                                {'~'} {state.mobileOrderInfo.expectedAmount.toString().slice(0, (state.mobileOrderInfo.expectedAmount.toString().indexOf('.')) + 6)}
                                {CurrencyCodeName[state.mobileOrderInfo.outCurrencyCode]}
                            </div>
                        </div>
                        <div className={classes.button__wrapper}>
                            <button className={classes.allWidth__button__active} onClick={() => {
                                // dispatch(backAction())
                            }}>
                                Transactions history
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            {renderMobileOrderStatus()}
        </>
    )
}